import type { ComponentType, ReactNode } from 'react';

interface ProviderProps {
  children: ReactNode;
}

export const combineProviders =
  (providers: ComponentType<ProviderProps>[]): ComponentType<ProviderProps> =>
  ({ children }: ProviderProps) =>
    providers.reduceRight((accumulator, Provider) => <Provider>{accumulator}</Provider>, children);
